hrd.charts.LineChart = hrd.charts.AbstractChart.extend({
	init: function(options, dynamicOptions, customChartOptions) {
		this.staticChartOptions = $.extend(true, this._specificChartOptions(), customChartOptions || {});
		this._super(options, dynamicOptions);
	},
	doChartOptions: function(){
		return this.staticChartOptions;
	},
	_adaptSpecificChart: function(staticOptions, dynamicOptions){
		staticOptions.line = {
			connectNull: dynamicOptions.connectNull
		}
	}
});